import { useEffect } from 'react';
import api from '../utils/api';

const HEARTBEAT_INTERVAL_MS = 60 * 1000;

function PresenceHeartbeat() {
  useEffect(() => {
    let cancelled = false;
    let intervalId = null;

    const sendHeartbeat = async () => {
      if (cancelled) return;
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        await api.post('/auth/presence');
      } catch (_) {
        // Presence is best-effort and should never interrupt app usage.
      }
    };

    sendHeartbeat();
    intervalId = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        sendHeartbeat();
      }
    };

    const handleFocus = () => {
      sendHeartbeat();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      cancelled = true;
      if (intervalId) window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return null;
}

export default PresenceHeartbeat;
